import { Grid, styled } from '@mui/material'

export const GridWrapper = styled(Grid)`
  &.error__container {
    border: 1px solid ${props => props.theme.palette.brand.gray1};
    background-color: ${props => props.theme.palette.brand.gray3};
    border-radius: 4px;
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }
`
export const ErrorTypography = styled('p')`
  text-align: center;

  &.error__title {
    font-weight: bold;
    margin: 48px auto 0;
  }

  &.error__description {
    display: block;
    max-width: 480px;
    margin: 16px auto;
  }
`

export const Logo = styled('img')`
  max-width: 220px;
  width: 100%;
`
